export default __webpack_public_path__ + "static/about-1-9b204109140159f8bab59e3fb16a3879.webp";